import { container, centered, centeredContent, fullContainerBackgroundImage, pageSection, pageSectionInner } from './layout.css';
import { buttonText, heading1, heading2, heading5, heroDescription, inputText, inputTextLabel, legal, linkButtonText, thankYouHeadline, thankYouSubHeadline } from './typography.css';

export const mixins = {
  layout: { container, centered, centeredContent, fullContainerBackgroundImage, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, inputText, inputTextLabel, legal, linkButtonText, thankYouHeadline, thankYouSubHeadline },
};
